import * as React from 'react';
import { Box, Modal, ModalProps, Slide } from '@mui/material';
import { SxProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CRModalProps extends ModalProps {
  width?: string | number,
  height?: string | number,
  disableSidePadding?: boolean,
  disableBackdropClick?: boolean,
  onExited?: () => void,
  paperPadding?: any,
  paperSx?: SxProps,
  modalScroll?: boolean;
}

export function CRModal(props: CRModalProps) {
  const {paperPadding, modalScroll, disableSidePadding, paperSx, sx = {}, ...rest} = props

  return <Modal
    closeAfterTransition
    sx={{
      display: 'flex',
      alignItems: modalScroll ? 'flex-start' : 'center',
      justifyContent: 'center',
      overflowY: modalScroll ? 'auto' : undefined,
      paddingLeft: disableSidePadding ? 0 : 320,
      padding: {xs: '40px 10px!important', lg: undefined},
      ...sx,
    }}
    {...rest}
  >
    <Slide direction={props.open ? 'up' : 'down'} in={props.open} onExited={props.onExited}>
      <Box sx={{
        position: 'relative',
        backgroundColor: '#fff',
        borderRadius: '10px',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.15)',
        padding: typeof paperPadding === 'undefined' ? '50px 36px 40px' : paperPadding,
        outline: 'none',
        display: 'flex',
        flexDirection: 'column',
        maxHeight: modalScroll ? undefined : '90vh',
        overflowY: 'auto',
        width: props.width,
        height: props.height,
        marginTop: modalScroll ? '50px' : undefined,
        marginBottom: modalScroll ? '50px' : undefined,
        ...paperSx
      }}>
        {props.children}
      </Box>
    </Slide>
  </Modal>
}
